import 'twin.macro'

import { useDeviceInfo } from 'hooks/useDeviceInfo'
import React, { useEffect, useState } from 'react'
import { JSX } from 'react/jsx-runtime'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { pathnames } from 'utils/steps'
function NavMenuCabinet() {
  const [activePage, setActivePage] = useState<string>('')
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const { isMobile } = useDeviceInfo()
  const handleReturnLink = () => {
    const paths = pathname.split('/')
    const result: JSX.Element[] | string = []
    paths.map((item, idx) => {
      switch (item) {
        case pathnames.main.replaceAll('/', ''):
          result.push(
            <a key={idx} href={pathnames.main}>
              {' '}
              {t('nav.main', { ns: 'cabinet' })}{' '}
            </a>
          )
          break
        case pathnames['personal-cabinet'].replaceAll('/', ''):
          result.push(
            <a key={idx} href={pathnames['personal-cabinet']}>
              {' '}
              {t('nav.cabinet', { ns: 'cabinet' })}{' '}
            </a>
          )
          break
        case pathnames['buy-card'].replaceAll('/', ''):
          result.push(
            <a key={idx} href={pathnames['buy-card']}>
              {' '}
              {t('nav.buy_card', { ns: 'cabinet' })}
            </a>
          )
          break
        case pathnames.statement.replaceAll('/', ''):
          result.push(
            <a key={idx} href={pathnames.statement}>
              {' '}
              {t('nav.statement', { ns: 'cabinet' })}
            </a>
          )
          break
      }
      idx !== paths.length - 1 && result.push('/')
    })
    return result
  }

  useEffect(() => {
    handleReturnLink()
  }, [])

  useEffect(() => {
    switch (pathname) {
      case pathnames['personal-cabinet']:
        setActivePage(`${t('nav.cabinet', { ns: 'cabinet' })}`)
        break
      case pathnames.statement:
        setActivePage(`${t('nav.buy_card', { ns: 'cabinet' })}`)
        break
      default:
        setActivePage('')
        break
    }
  }, [pathname])

  return (
    <div>
      <nav tw='text-secondary text-s14 sm:mt-0 mt-5'>
        {handleReturnLink().map(item => item)}
        {isMobile && <p tw='text-[32px] text-primary font-bold mt-10'>{activePage}</p>}
        {/* <a href={pathnames.main}>{t('nav.main', { ns: 'cabinet' })}</a> / {t('nav.cabinet', { ns: 'cabinet' })} */}
      </nav>
    </div>
  )
}

export default NavMenuCabinet
